<template>
  <a-drawer
    :width="width"
    :visible="visible"
    @ok="handleOk"
    :headerStyle="{paddingTop:'0px'}"
    :bodyStyle="{padding: 0 }"
    @close="handleCancel"
   >
    <div class="model-top">
      信息重复
    </div>
   <div style="padding-bottom: 40px">
     <div class="top-tips">
       <img src="@/assets/driver/err-tips.png">
       {{type==1?'手机号':'身份证号'}}被以下信息占用
     </div>

     <div class="ass-share" v-for="item in dataSource">
       <div class="ass-share-left">
         <div class="ass-share-left-item">
           <span class="label">客户姓名</span>
           <span class="val">{{item.driverName}}</span>
         </div>
         <div class="ass-share-left-item">
           <span class="label">{{type==1?'手机号':'身份证号'}}</span>
           <span class="val">{{type==1?item.phone:item.idNumber}}</span>
         </div>
         <div class="ass-share-left-item">
           <a-button type="primary" @click="beShare(item.id)">前往查看</a-button>
         </div>
       </div>

     </div>

     <div class="zxdbs" v-if="type==1" @click="handleCancel">
       这些都不是，继续添加
     </div>
   </div>
  </a-drawer>
</template>

<script>

  import { getAction } from '@/api/manage'
  export default {
    name: 'AddShareList',
    components: {

    },
    data () {
      return {
        title:'注意',
        width:530,
        visible: false,
        disableSubmit: false,
        dataSource:[],
        driverId:'',
        str:'',
        type:1
      }
    },
    methods: {
      edit (driverId,driverList,str,type) {
        this.visible=true
        this.driverId= driverId;
        this.dataSource = driverList
        this.str = str;
        this.type = type
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(data){
        this.$emit('ok',data);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },beShare(driverId){
        let that = this;
        let formData = {
          "id":driverId
        }
        getAction("/dm/dmShareDriver/beShare",formData).then((res)=>{
          if(res.success){
              that.$message.success("操作成功!");
              that.$emit("ok",driverId);
              that.visible = false
          }else{
            if(res.message=="已存在共享人数据"){
              // this.$confirm({
              //   title: '提示',
              //   okText: '立即查看',
              //   cancelText: '取消',
              //   content: '您已经是该司机的共享人了，是否去查看？',
              //   onOk: () => {
              //
              //   },
              //   onCancel: () => {
              //
              //   }
              // })
              this.$emit("ok",driverId)
              that.visible = false
            }else{
              that.$message.warning(res.message);
            }

          }
        })
      }
    }
  }
</script>
<style scoped>
  .model-top{
    height: 92px;
    line-height: 92px;
    color: #0A1629;
    font-size: 22px;
    border-bottom: 1px solid rgba(230, 237, 245, 1);
    padding-left: 24px;
  }
  .top-tips{
    height: 72px;
    line-height: 72px;
    color: rgba(246, 81, 96, 1);
    padding-left: 24px;
  }
  .top-tips img{
    width: 20px;
    height: 20px;
    vertical-align:sub;
  }
  .j-table-force-nowrap{
    padding: 20px 40px 0 40px;
  }
  .ass-share{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 12px 24px;
    height: 98px;
    background: rgb(232, 241, 255);
    border-radius: 12px;

  }
  .ass-share .ass-share-left{
    flex: 1;
    display:flex;
    align-items: center;
  }
  .ass-share .ass-share-left .ass-share-left-item{
    flex:1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }
  .ass-share-left-item .label{
    color: rgba(145, 146, 158, 1);
  }
  .ass-share-left-item .val{
    color:rgba(10, 22, 41, 1);
    font-size: 16px;
    width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
  }
  .zxdbs{
    color: rgb(63, 140, 255);
    margin-left: 26px;
    cursor: pointer;
  }
</style>